import type { OutputStorageType } from '@/api/media/shared-storage-types';

export type StorageKind = OutputStorageType;

export interface StorageFormErrorMap {
  [key: string]: string | undefined;
}

export interface S3FormState {
  name: string;
  access_key_id: string;
  secret_access_key: string;
  region: string;
  bucket: string;
  endpoint: string;
  useCustomEndpoint: boolean;
}

export interface FtpFormState {
  name: string;
  host: string;
  port: string;
  username: string;
  password: string;
  pasv: boolean;
}

export interface SftpFormState {
  name: string;
  host: string;
  port: string;
  username: string;
  password: string;
}

export interface HttpFormState {
  name: string;
  host: string;
  auth_type: 'none' | 'basic';
  username: string;
  password: string;
}

export interface StorageDraftMap {
  s3: S3FormState;
  ftp: FtpFormState;
  sftp: SftpFormState;
  http: HttpFormState;
  webdav: HttpFormState;
}

export const STORAGE_KIND_OPTIONS: Array<{ value: StorageKind; label: string }> = [
  { value: 's3', label: 'S3' },
  { value: 'ftp', label: 'FTP' },
  { value: 'sftp', label: 'SFTP' },
  { value: 'http', label: 'HTTP' },
  { value: 'webdav', label: 'WebDAV' },
];

export const DEFAULT_DRAFTS: StorageDraftMap = {
  s3: { name: '', access_key_id: '', secret_access_key: '', region: 'us-east-1', bucket: '', endpoint: 'https://s3.amazonaws.com', useCustomEndpoint: false },
  ftp: { name: '', host: '', port: '21', username: '', password: '', pasv: true },
  sftp: { name: '', host: '', port: '22', username: '', password: '' },
  http: { name: '', host: '', auth_type: 'none', username: '', password: '' },
  webdav: { name: '', host: '', auth_type: 'basic', username: '', password: '' },
};

export interface EditRow {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  raw: any;
  type: string;
  originalId: number;
}
